import React from 'react';
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Box,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { Repository } from '../../api/models/Repository';
import { ProvisioningStatus } from '../../api/models/ProvisioningStatus';

interface RepositoriesRowProps {
  repository: Repository;
  index: number;
  totalRepositories: number;
  isLoading: boolean;
  onDeleteRepository: (repositoryName: string) => void;
}

const RepositoriesRow: React.FC<RepositoriesRowProps> = ({
  repository,
  index,
  totalRepositories,
  isLoading,
  onDeleteRepository,
}) => {
  const isPendingStatus = (status: string): boolean =>
    status.toLowerCase() === ProvisioningStatus.PENDING;

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case ProvisioningStatus.PENDING:
        return 'warning';
      case ProvisioningStatus.ACTIVE:
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <>
      <ListItem>
        <ListItemText
          primary={
            <>
              <Typography variant="subtitle1" component="span" sx={{ marginRight: 1 }}>
                {repository.repositoryName}
              </Typography>
              <Chip
                label={repository.status}
                size="small"
                color={getStatusColor(repository.status) as any}
              />
            </>
          }
          secondary={
            <>
              <Typography variant="body2" color="text.secondary" component="span">
                Created by: {repository.createdBy}
              </Typography>
              <br />
              <Typography variant="body2" color="text.secondary" component="span">
                Created on: {new Date(repository.createdOn).toLocaleDateString()}
              </Typography>
            </>
          }
          primaryTypographyProps={{ component: 'div' }}
          secondaryTypographyProps={{ component: 'div' }}
        />
        <ListItemSecondaryAction>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              edge="end"
              onClick={() => onDeleteRepository(repository.repositoryName)}
              disabled={isLoading || isPendingStatus(repository.status)}
              title={
                isPendingStatus(repository.status)
                  ? 'Cannot delete pending repositories'
                  : 'Delete repository'
              }
            >
              <DeleteOutline />
            </IconButton>
          </Box>
        </ListItemSecondaryAction>
      </ListItem>
      {index < totalRepositories - 1 && <Divider />}
    </>
  );
};

export default RepositoriesRow;
